import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';
import './Footer.css';

const Footer = () => {
  const { t } = useI18n();

  return (
    <footer className="app-footer">
      <Link to="/contact" className="app-footer-link">
        {t('footer.contact')}
      </Link>
      <span className="app-footer-sep" aria-hidden="true"> · </span>
      <Link to="/privacy" className="app-footer-link">
        {t('footer.privacy')}
      </Link>
    </footer>
  );
};

export default Footer;
